
<template>
    <div class="pekerjaan__pekerjaan-sidebar h-full">

        <!-- compose tag -->
        <vs-prompt
          class="pekerjaan-compose"
          title="New Tag"
          accept-text="Submit"
          @cancel="clearFields"
          @accept="submitTag"
          @close="clearTag"
          :is-valid="validateTag"
          :active.sync="activePromptTags">
          <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
            <form @submit.prevent>
              <vs-row>
                <vs-col vs-w="8">
                  <vs-input label="Nama Tag" v-model="dataTag" class="w-full pr-2" name="item-tag" v-validate="'required'" />
                  <span class="text-danger text-sm" v-show="errors.has('item-tag')">{{ errors.first('item-tag') }}</span>
                </vs-col>

                <vs-col vs-w="4">
                  <input v-model="dataColorx" type="color" name="item-color" class="mt-8">
                </vs-col>
              </vs-row>
            </form>
          </component>
        </vs-prompt>

        <component :is="scrollbarTag" class="pekerjaan-filter-scroll-area" :settings="settings" :key="$vs.rtl">
            <div class="px-8 pt-4 flex flex-col">
              <router-link tag="span" :to="`${baseUrl}/all`" class="flex items-center mt-4 mb-2 cursor-pointer" :class="{'text-primary': pekerjaanFilter == 'all'}">
                <feather-icon icon="LayersIcon" class="cursor-pointer mr-4" svg-classes="h-6 w-6" />
                <span class="text-lg" :class="{'text-primary': pekerjaanFilter == 'all'}">All</span>
              </router-link>
            </div>
            <vs-divider></vs-divider>
            <div class="pekerjaan__labels">
                <div class="flex items-center flex-wrap justify-between px-4 pb-4">
                    <div class="flex items-center">
                      <h5>Tags</h5>
                    </div>
                    <div class="flex">
                        <feather-icon icon="PlusIcon" class="cursor-pointer ml-5" svg-classes="h-6 w-6" @click="activePromptTags = true" />
                    </div>
                </div>
                <div class="pekerjaan__lables-list px-6">
                    <router-link tag="span" class="pekerjaan__label flex items-center mb-4 cursor-pointer" v-for="(tag, index) in pekerjaanTags" :key="index" :to="`${baseUrl}/${tag.slug}`">
                        <vs-chip :color="tag.color"></vs-chip>
                        <span class="ml-2 text-lg" :class="{'text-primary': pekerjaanFilter == tag.slug}">{{ tag.name }}</span>
                    </router-link>
                </div>
            </div>
            <vs-divider></vs-divider>
            <router-link tag="span" class="pekerjaan__label flex items-center mb-4 ml-6 cursor-pointer" :to="`${baseUrl}/trash`">
              <feather-icon icon="TrashIcon" class="cursor-pointer mr-4" svg-classes="h-6 w-6" />
              <span class="text-lg" :class="{'text-primary': pekerjaanFilter == 'trash'}">Trash</span>
            </router-link>
        </component>

    </div>
</template>

<script>
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { mapGetters } from 'vuex'

export default {
  props: {
    pekerjaanTags: {
      type: Array,
      required: true
    },
    pekerjaanFilter: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      activePrompt: false,
      activePromptTags: false,

      dataTag: null,
      dataColorx: null,
      editorOption: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'link', 'blockquote', 'code-block'],
            [{ 'header': 1 }, { 'header': 2 }],
            [{ 'list': 'ordered' }, { 'list': 'bullet' }],
            [{ 'font': [] }]
          ]
        },
        placeholder: 'Message'
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.30
      }
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.dataBidang !== 'pilih' && this.dataDivisi !== 'pilih'
    },
    validateTag () {
      return !this.errors.any() && this.dataTag && this.dataColorx
    },
    baseUrl () {
      const path = this.$route.path
      return path.slice(0, path.lastIndexOf('/'))
    },
    pekerjaanMeta () {
      return this.$store.state.pekerjaan.meta
    },
    filters () {
      return this.$store.state.pekerjaan.filters
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    ...mapGetters({
      user : 'auth/user',
    })
  },
  mounted(){
  },
  methods: {
    clearFields () {
      this.$nextTick(() => {
        this.dataBidang = 'pilih'
        this.dataDivisi = 'pilih'
        this.changeDivisi = false
      })
    },
    clearTag () {
      this.$nextTick(() => {
        this.dataTag = null
        this.dataColorx = null
      })
    },
    sendPekerjaan () {
      this.$vs.loading()
      const obj = {
        id: this.$route.params.id,
        relations: {
          //pekerjaan_bidang: this.dataBidang,
          pekerjaan_divisi: this.dataDivisi
        }
      }

      this.$store.dispatch('pekerjaan/addFilter', obj)
      .then((response) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Berhasil',
          color  : 'success',
          text  : response.message,
        })
      })
      .catch(error => {
        this.$vs.loading.close()
        let {data} = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
      this.clearFields()
    },
    submitTag () {
      this.$vs.loading()
      const obj = {
        object_slug: this.$route.params.id,
        name: this.dataTag,
        term_group: 0,
        parent: 0,

        meta : {
          color: this.dataColorx
        },

        taxonomy: 'tag'
      }

      this.$store.dispatch('pekerjaan/addTag', obj)
      .then((response) => {
        this.$vs.loading.close()
        this.$vs.notify({
          title: 'Berhasil',
          color  : 'success',
          text  : response.message,
        })
      })
      .catch(error => {
        this.$vs.loading.close()
        let {data} = error.response
        this.$vs.notify({
          title: 'Error',
          text: data.message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      })
      this.clearFields()
    }
  },
  components: {
    quillEditor,
    VuePerfectScrollbar
  }
}

</script>

